var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterPhoneCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.268,
    height: 18.295,
    viewBox: "0 0 18.268 18.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call-svgrepo-com",
    transform: "translate(-0.344 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(0.344 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M14.79,37.681a1.8,1.8,0,0,0-1.305-.6,1.861,1.861,0,0,0-1.321.595l-1.22,1.216c-.1-.054-.2-.1-.3-.154-.139-.069-.27-.135-.382-.2a13.262,13.262,0,0,1-3.178-2.9,7.824,7.824,0,0,1-1.043-1.645c.317-.29.61-.591.9-.88.108-.108.216-.22.324-.328a1.772,1.772,0,0,0,0-2.672L6.21,29.059c-.12-.12-.243-.243-.359-.367-.232-.239-.475-.487-.726-.718a1.828,1.828,0,0,0-1.294-.568,1.891,1.891,0,0,0-1.313.568l-.008.008L1.2,29.306A2.825,2.825,0,0,0,.36,31.1a6.769,6.769,0,0,0,.494,2.865,16.625,16.625,0,0,0,2.954,4.927,18.171,18.171,0,0,0,6.051,4.738,9.427,9.427,0,0,0,3.4,1c.081,0,.166.008.243.008a2.91,2.91,0,0,0,2.228-.958c0-.008.012-.012.015-.019a8.779,8.779,0,0,1,.676-.7c.166-.158.336-.324.5-.5a1.926,1.926,0,0,0,.583-1.336,1.856,1.856,0,0,0-.595-1.324Zm1.382,4.066s0,0,0,0c-.151.162-.305.309-.471.471a10.153,10.153,0,0,0-.745.772A1.861,1.861,0,0,1,13.5,43.6c-.058,0-.12,0-.178,0a8.375,8.375,0,0,1-3.012-.9,17.152,17.152,0,0,1-5.7-4.464,15.676,15.676,0,0,1-2.78-4.63A5.513,5.513,0,0,1,1.4,31.186a1.772,1.772,0,0,1,.533-1.147l1.317-1.317a.878.878,0,0,1,.587-.274.826.826,0,0,1,.564.27l.012.012c.236.22.459.448.7.691.12.124.243.247.367.375L6.531,30.85a.737.737,0,0,1,0,1.2c-.112.112-.22.224-.332.332-.324.332-.633.641-.969.942-.008.008-.015.012-.019.019a.788.788,0,0,0-.2.877l.012.035a8.463,8.463,0,0,0,1.247,2.035l0,0A14.172,14.172,0,0,0,9.7,39.411a5.271,5.271,0,0,0,.475.259c.139.07.27.135.382.2.015.008.031.019.046.027a.837.837,0,0,0,.382.1.826.826,0,0,0,.587-.266l1.321-1.321a.874.874,0,0,1,.583-.29.786.786,0,0,1,.556.282l.008.008,2.128,2.128A.763.763,0,0,1,16.172,41.747Z",
    transform: "translate(-0.344 -26.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M245.373,86.959a4.969,4.969,0,0,1,4.047,4.047.518.518,0,0,0,.514.432.688.688,0,0,0,.089-.008.522.522,0,0,0,.429-.6,6.009,6.009,0,0,0-4.9-4.9.524.524,0,0,0-.6.425A.516.516,0,0,0,245.373,86.959Z",
    transform: "translate(-235.499 -82.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M257.443,8.07A9.894,9.894,0,0,0,249.381.008a.521.521,0,1,0-.17,1.027,8.838,8.838,0,0,1,7.205,7.205.518.518,0,0,0,.514.432.689.689,0,0,0,.089-.008A.512.512,0,0,0,257.443,8.07Z",
    transform: "translate(-239.183 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhoneCallIcon);
export default __webpack_public_path__ + "static/media/footer-phone-call-icon.1bab4c88125c34b5c8f8b9e08134dd3e.svg";
export { ForwardRef as ReactComponent };